module.exports = new __parcel__URL__("vm_routes_logo.3619f701.svg").toString();